
/**
 * 西班牙语（es）
 */

export default {
  // 刊登编辑页面 edit
  publishEdit: {
    listings: 'lista',
    Platform: 'plataforma',
    Store: 'Loja',
    ProductTitle: 'Nome do produto',
    Tags: 'rótulo',
    Custom: 'hábito',
    Collections: 'Colecção',
    Category: 'Categoría',
    Description: 'descrever',
    Variants: 'variante',
    Images: 'imagem',
    listNow: 'Agora lista',
    CancelEditing: 'Cancelar edição',
    tips1: 'Não mais do que 40000 caracteres',
    tips2: 'Apenas imagens JPG, JPEG e PNG são suportadas.',
    ShippingMethod: 'Tipo de transporte',
    Product: 'produto',
    SKU: 'SKU',
    size: 'tamanho',
    color: 'cor',
    ProductCost: 'Costo del producto',
    ShippingCost: 'carga',
    CompareAtPrice: 'Comparação de preços',
    SuggestedPrice: 'Preço sugerido',
    Profi: 'Beneficios',
    Quantity: 'número',
    WarehouseName: 'Nombre del almacén',
    tips3: 'Incluindo companhias de navegação',
    tips4: 'Suporta até 250 imagens',
    tips5: 'Suporta até 40 imagens',
    SuggestedPriceTips1: 'Precio de venta = precio original * (1 + más) + flete',
    CompareAtPriceTips1: 'Comparación por precio = costo del producto * (1 + margen de beneficio) + costo del transporte',
    SuggestedPriceTips2: '(If you have selected "Including Shipping Cost")',
    SuggestedPriceTips3: '(si ha seleccionado "incluido el flete")',
    SuggestedPriceTips4: 'Precio de venta = precio original + Ganancia + flete',
    CompareAtPriceTips2: 'Comparación por precio = costo del producto + Ganancia + costo del transporte',
    NewPrice: 'Nuevo precio',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    Percentage: 'Porcentaje',
    OneClickModification: 'Modificación de un clic',
    FixedProfit: 'Beneficio fijo',
    ProductionEditor: 'editor de productos',
    SyncCollection: 'Conjunto sincrónico',
    selectContent: 'Seleccionar contenido',
    ShippingFrom: 'Punto de partida',
    ShippingTo: 'Punto final',
    EstimatedDeliveryTime: 'Tiempo estimado de entrega',
    NoPictures: 'No hay fotos',
    loadingText: 'Cargar...',
    repeat: '¡Repito!',
    IncorrectLogisticsInformation: 'El método de envío no puede estar vacío',
    PictureCannotBeEmpty: 'La imagen no puede estar vacía',
    SKUCannotBeEmpty: 'SKU no puede estar vacío',
    inputLength: 'Longitud inferior a 255',
    richTextCheck: 'El número de palabras de texto rico no excederá de 40000',
    CompareAtPriceCheck: 'La comparación en el precio debe ser alta que el precio sugerido',
    CompareAtPriceCheckShoplazza: 'La comparación de precios debe ser superior a',
    titleCheck: 'El título no puede estar vacío',
    DescriptionCheck: 'La descripción no puede estar vacía',
    ShelfStatusUp: 'este producto se venderá en la tienda por adelantado',
    ShelfStatusDowm: 'este producto ha estado en la tienda antes.',
    ProfitMargin: 'Margen de beneficio',
    imageMaxLengthTips: 'Sólo se pueden seleccionar hasta 250 imágenes',
    imageMaxLengthTips2: 'Sólo se pueden seleccionar hasta 40 imágenes',
    tagLength: 'Establecer hasta 10 etiquetas',
    isFilterDuplicateSpuText: 'El mismo producto se repetirá en el mercado',
    beenListed: 'Fracaso. El proyecto ya está listado.',
    tips6: 'El producto de la variante SKU no puede estar vacío.',
    tips7: 'Publicar consejos',
    LogisticsError: 'No se puede obtener logística, Póngase en contacto con nuestro equipo de servicio al cliente',
    tips8: 'Seleccione hasta nueve imágenes',
    categoryIdCheck: 'Porfavor seleccione una categoría',
    tips9: 'Hay un cambio en la información del producto Kaka, haga clic en "Actualizar" para obtener la información de cambios más reciente.',
    Update: 'Actualizar',
    optionEmptyTip: 'Las opciones no pueden estar vacías'
  },
  publishListings: {
    listings: 'Lista',
    Published: 'Publicación',
    Active: 'Activa',
    Hidden: 'Oculto',
    Update: 'Actualizar',
    Deactivate: 'Desactivar',
    Inactive: 'Inactiva',
    Suspended: 'Suspendida',
    Reviewing: 'Revisando',
    Failed: 'Fallida',
    Frozen: 'Congelada',
    WaitingForUpdate: 'Esperando actualización',
    ListingQueue: 'Cola de lista',
    Deleted: 'Borrar',
    productSelected: 'Productos seleccionados',
    Product: 'Productos',
    ProductId: 'ID del producto',
    priceScope: 'Rango de precios',
    CompareAtPrice: 'Comparación de precios',
    Inventory: 'Inventario',
    EditProduct: 'Editar productos',
    More: 'Más',
    Synchronous: 'Sincrónica',
    Relist: 'Volver a iniciar sesión',
    Activate: 'Activar',
    PublishedIn: 'Publicado en ...',
    Delete: 'Borrar',
    synType1Title: 'En la lista...',
    synType5Title: 'Sobre volver a cotizar...',
    synType5TitleTT: 'Al activar...',
    synType4Title: 'Escondido en una tienda...',
    synType4TitleTT: 'Siendo Desactivado de la Tienda...',
    synType10Title: 'Sincronización...',
    synType2Title: 'Sincronizar la información de edición..',
    noProduct: 'Lo siento, aún no ha añadido el producto',
    ChooseProduct: 'Selección de productos',
    ConnectANewStore: 'Conectar una nueva tienda',
    hiddenComfirmTitle: 'Estás seguro de que quieres sacar el producto de la tienda?',
    RelistComfirmTitle: 'está seguro de que desea volver a iniciar sesión en la tienda?',
    deleteComfirmTitle: '¿Está seguro de que quiere eliminar el producto de su tienda?',
    synType3Title: 'Borrar...',
    searchBy: 'Contenido de la búsqueda',
    SelectStore: 'Elija una tienda',
    store: 'Tienda',
    productName: 'Nombre del producto',
    available: 'Disponible',
    soldOut: 'Agotado',
    notAvailable: 'Inutilizable',
    mptyTips1: '¡Su lista de pedidos está vacía!',
    emptyTips2: 'Puede administrar y procesar sus listados aquí',
    createProduct: 'Crear producto'
  },
  productList: {
    wishList: 'Lista de deseos',
    productList: 'Lista de productos',
    Delete: 'Borrar',
    productSelected: 'Productos seleccionados',
    deleteTip1: '¿Está seguro de que desea eliminar el producto seleccionado?',
    submit: 'Submission',
    cancel: 'Cancelar',
    Description: 'Descripción',
    Inventory: 'Inventario',
    Price: 'Precio',
    ProductType: 'Tipo de producto',
    Action: 'Acción',
    Detail: 'Detalles',
    more: 'Más',
    ListToStore: 'Lista a almacenar',
    customized: 'Personalizado',
    goodsInStock: 'Existencias de bienes',
    tatusTips: 'El producto no está disponible.',
    canFind: 'Lo siento, no puedo encontrarlo.',
    ItemNo: 'Número de proyecto',
    contentPlaceholder: 'Introduzca la palabra clave del producto',
    Listing: 'Listado',
    YourPrice: 'Su precio',
    From: 'De',
    ShipTo: 'Barco a',
    Cancel: 'Cancelar',
    ListNow: 'Lista ahora',
    Platform: 'Plataforma',
    Store: 'Tienda',
    ShipMyOdersMostTo: 'Orden enviada más lejos',
    ShippingMethod: 'Canal de transporte',
    logisticsTips: 'Siempre que elija uno de los lugares de entrega, recepción y logística, debe seleccionar todos estos',
    batchPublishTips: 'Cargar hasta 100 listas a la vez',
    storeTips: 'Solo se puede subir a 1 tienda a la vez',
    priceTips: 'Su precio = precio * introduzca un factor (introduzca el tiempo en lugar de la tasa).',
    shipTips: 'El modelo logístico seleccionado sólo se utiliza como logística soportada por el sistema',
    ShippingMethodTips: 'Opcional (se puede ajustar antes del envío)',
    inputPlaceholder: 'Contenido de la búsqueda',
    haveShelves: 'Lista fallida: contiene elementos no disponibles.',
    textareaPlaceholder: 'Separar varias búsquedas con comas o saltos de línea',
    repeatListTip: 'El mismo producto se repetirá en el mercado',
    repeatList: 'Lista duplicada',
    priceRatioGT20Tip: 'El producto que cargue será 20 veces el precio de venta',
    yourPrice: 'Su precio',
    Status: 'Estado',
    selectProductStatus: 'Seleccionar estado del producto',
    selectPublishStatus: 'Seleccionar estado de publicación',
    removeSelectedProducts: 'Eliminar productos seleccionados',
    removeunavailableProducts: 'Eliminar productos no disponibles',
    Tips1: '¿Está seguro de que desea eliminar todos los productos no disponibles o agotados?',
    Tips2: 'Por favor seleccione el producto primero.'
  },
  batchTasks: {
    batchTasks: 'Tareas por lotes',
    Status: 'Posición',
    contentPlaceholder: 'Buscar',
    Number: 'Número',
    StoreInformation: 'Información almacenada',
    ItemNo: 'Número de proyecto',
    PublicationSituation: 'Estado de publicación',
    FailedToLoad: 'No se puede cargar',
    Success: 'éxito',
    uploading: 'Subir',
    ListingFailed: 'Fracaso en la lista',
    CreationTime: 'tiempo de creación',
    Pending: 'por determinar',
    Processing: 'Tratamiento',
    Completed: 'hecho',
    contentPlaceholder2: 'Número de artículo de búsqueda',
    Platform: 'Plataforma',
    Store: 'Centro Comercial',
    Product: 'Productos',
    ReasonForFailure: 'Causas del fracaso',
    data: 'Datos'
  },
  Publish: {
    ProductList: {
      Index: {
        ListingQueue: 'Cola de listado',
        Published: 'Publicado'
      },
      Components: {
        MTList: {
          SelectAll: 'Seleccionar todo',
          Price: 'Precio',
          Inventory: 'Inventario',
          Delete: 'Borrar',
          ListToStore: 'Lista para almacenar',
          FavoriteItem: 'Sorry, you have not added a product',
          ChooseProduct: 'Choose Product'
        },
        BatchListToStoreModal: {
          Update: 'Actualizar',
          SuggestedPrice: 'Precio sugerido',
          Multiplier: 'Multiplicador',
          ShippingCost: 'costo de envío',
          CompareAtPrice: 'Comparar en Precio',
          Tips1: 'Comparar al precio tiene que ser mayor que el precio sugerido',
          Tips2: 'Para artículos que ya han sido listados',
          Skip: 'Saltar',
          Duplicate: 'Duplicado',
          Listing: 'Listado',
          SizeUnit: 'Unidad de tamaño',
          Platform: 'Plataforma',
          Store: 'Almacenar',
          Collection: 'Recopilación',
          Categorys: 'Categorías',
          Tags: 'Etiquetas',
          SugestPrice: 'Precio sugerido',
          Explain: 'Si se actualiza el título, la descripción, el tamaño, la variante o la imagen del producto Kaka asociado con su listado seleccionado, los últimos cambios se sincronizarán automáticamente con su tienda.',
          SPExplain: 'El listado que seleccionó se actualizará según la información que configuró en la tienda kaka.'
        }
      }
    },
    Listings: {
      Components: {
        TableList: {
          Authorization: 'Autorización',
          Expires: 'caduca',
          Tips1: 'El producto ha sido eliminado de',
          ReList: 'volver a listar',
          Tips2: 'Ver en "Eliminado"',
          NoExist: 'No existe'
        },
        MTList: {
          SelectAll: 'Seleccionar todo',
          ProductId: 'ID del Producto',
          ProductCoat: 'Costo del producto',
          Inventory: 'Inventario',
          Delete: 'Borrar',
          Hidden: 'Oculto',
          Published: 'Publicado'
        },
        MTDetail: {
          Listing: 'Listado',
          Tips1: 'La edición de la información del producto solo se admite en la versión para computadora',
          ProductId: 'ID del Producto',
          ProductCoat: 'Costo del producto',
          Inventory: 'Inventario',
          ProductCost: 'Costo del producto'
        }
      }
    },
    Edit: {
      Index: {
        SizeUnit: 'Unidad de tamaño',
        Description: 'Descripción',
        Variants: 'variantes',
        Images: 'Imágenes'
      },
      Components: {
        Variants: {
          SuggestedPrice: 'Precio sugerido',
          CompareAtPrice: 'CompararPrecio'
        },
        TopInfo: {
          Update: 'Actualizar',
          Categorys: 'Categorías',
          PoductsType: 'tipo de productos',
          NewTag: 'Nueva etiqueta',
          SelectTags: 'seleccionar etiquetas',
          Published: 'Publicado',
          Hidden: 'Oculto'
        },
        ImageList: {
          MediaSelected: 'medios seleccionados'
        }
      }
    },
    CustomProduct: {
      List: {
        Index: {
          CustomizeOnDemand: 'Personalizar a pedido',
          PrintOnDemand: 'Imprime a solicitud'
        },
        Components: {
          PaySampleFee: {
            Others: 'Otros',
            PayNow: 'Pagar ahora'
          },
          EmptyData: {
            Tips1: 'Envíe sus requisitos personalizados'
          }
        }
      },
      Detail: {
        Index: {
          ProductName: 'Nombre del producto',
          Material: 'Material'
        }
      }
    },
    BatchTasks: {
      Index: {
        ListingQueue: 'Cola de listado',
        Back: 'Atrás',
        Pending: 'pendiente',
        Processing: 'Procesando',
        Completed: 'Terminado'
      }
    }
  },
  // 我的的设计
  userDesign: {
    MyDesign: 'Mi Diseño',
    Tips1: 'Buscar artículo No',
    ProductSelected: 'Producto Seleccionado',
    ItemNo: 'Número de Artículo',
    Price: 'Precio',
    DesignTime: 'Tiempo de Diseño',
    Action: 'Acción',
    Actions: 'Acciones',
    Detail: 'Detalle',
    Remove: 'Eliminar',
    Tips2: '¿Estás seguro de eliminar el producto seleccionado?',
    Notice: 'Aviso',
    Confirm: 'Confirmar',
    Cancel: 'Cancelar',
    Tips3: 'Print On Demand utiliza un proceso de transferencia térmica 3D, por lo que modificar el color de la prenda sólo modifica el color de la capa exterior, y la capa interior siempre es blanca.'
  }
}
